
import {Component, Input} from '@angular/core';
import {MatTooltip} from '@angular/material/tooltip';
import {MiddleEllipsisPipe} from '../../pipes/middle-ellipsis.pipe';

@Component({
  selector: 'app-additional-user-info',
  imports: [
    MatTooltip,
    MiddleEllipsisPipe
  ],
  templateUrl: './additional-user-info.component.html',
  styleUrl: './additional-user-info.component.scss'
})
export class AdditionalUserInfo {
  @Input() text: string | null | undefined;
  @Input() maxLength = 64;

  protected get isTruncated(): boolean {
    return !!this.text && this.maxLength > 3 && this.text.length > this.maxLength;
  }

  protected get tooltipText(): string {
    return this.text ?? '';
  }
}
